(function () {
  'use strict';
  var T = window.theme || {};
  var S = T.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* =====================================================================
     Drawer / dialog helper (focus trap, Escape, focus restore, scroll lock)
     ===================================================================== */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var openStack = [];
  function focusables(c) { return $$(FOCUSABLE, c).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; }); }

  function openDrawer(el, opts) {
    if (!el || el.classList.contains('is-open')) return;
    opts = opts || {};
    el.__last = document.activeElement;
    el.hidden = false;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (!opts.noLock) document.body.classList.add('no-scroll');
    openStack.push(el);
    var f = focusables(el);
    var target = $('[data-autofocus]', el) || f[0];
    if (target) setTimeout(function () { target.focus(); }, 30);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openStack = openStack.filter(function (x) { return x !== el; });
    if (!openStack.length) document.body.classList.remove('no-scroll');
    if (el.__last && el.__last.focus) el.__last.focus();
    if (el.hasAttribute('data-popup')) { setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 250); }
  }
  window.themeUI = { openDrawer: openDrawer, closeDrawer: closeDrawer, esc: esc };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openLoc = $('[data-loc].open');
      if (openLoc) {
        openLoc.classList.remove('open');
        var lbtn = $('[data-loc-toggle]', openLoc);
        if (lbtn) { lbtn.setAttribute('aria-expanded', 'false'); lbtn.focus(); }
        return;
      }
    }
    var top = openStack[openStack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      if (top.id === 'MobileMenu') { var b = $('[data-menu-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); }
      closeDrawer(top);
      return;
    }
    if (e.key === 'Tab') {
      var f = focusables(top);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* =====================================================================
     Delegated clicks
     ===================================================================== */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Mobile menu */
    var ham = t.closest('[data-menu-toggle]');
    if (ham) {
      var mm = document.getElementById('MobileMenu');
      if (mm) {
        var opening = !mm.classList.contains('is-open');
        if (opening) { openDrawer(mm); ham.setAttribute('aria-expanded', 'true'); }
        else { closeDrawer(mm); ham.setAttribute('aria-expanded', 'false'); }
      }
      return;
    }
    if (t.closest('[data-menu-close]')) {
      var m2 = document.getElementById('MobileMenu');
      closeDrawer(m2);
      var h2 = $('[data-menu-toggle]'); if (h2) h2.setAttribute('aria-expanded', 'false');
      return;
    }

    /* Country / language panel (supports several instances) */
    var lt = t.closest('[data-loc-toggle]');
    if (lt) {
      var loc = lt.closest('[data-loc]');
      $$('[data-loc].open').forEach(function (o) { if (o !== loc) { o.classList.remove('open'); var ob = $('[data-loc-toggle]', o); if (ob) ob.setAttribute('aria-expanded', 'false'); } });
      var isOpen = loc.classList.toggle('open');
      lt.setAttribute('aria-expanded', isOpen);
      if (isOpen) { var first = $('.loc-panel button[aria-pressed="true"]', loc) || $('.loc-panel button', loc); if (first) first.focus(); }
      return;
    }
    var lc = t.closest('[data-loc-close]');
    if (lc) {
      var l2 = lc.closest('[data-loc]');
      l2.classList.remove('open');
      var lb = $('[data-loc-toggle]', l2); if (lb) { lb.setAttribute('aria-expanded', 'false'); lb.focus(); }
      return;
    }
    if (!t.closest('.loc-panel')) {
      $$('[data-loc].open').forEach(function (o) { o.classList.remove('open'); var ob = $('[data-loc-toggle]', o); if (ob) ob.setAttribute('aria-expanded', 'false'); });
    }

    /* Footer accordions (mobile) */
    var fc = t.closest('[data-fcol-toggle]');
    if (fc) { var nowOpen = fc.getAttribute('aria-expanded') !== 'true'; fc.setAttribute('aria-expanded', nowOpen ? 'true' : 'false'); var col = fc.closest('.fcol'); if (col) col.classList.toggle('is-open', nowOpen); return; }

    /* Filter drawer */
    var ft = t.closest('[data-filter-toggle]');
    var panel = document.getElementById('FilterPanel');
    if (ft && panel) {
      var open = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      var back = $('.fback'); if (back) back.classList.toggle('is-open', open);
      ft.setAttribute('aria-expanded', open);
      if (open && window.matchMedia('(max-width: 1024px)').matches) { document.body.classList.add('no-scroll'); var fx = $('.fpanel-x', panel); if (fx) fx.focus(); }
      else document.body.classList.remove('no-scroll');
      return;
    }
    if (t.closest('[data-filter-close]') && panel) {
      panel.classList.remove('is-open');
      var bk = $('.fback'); if (bk) bk.classList.remove('is-open');
      var tg = $('[data-filter-toggle]'); if (tg) { tg.setAttribute('aria-expanded', 'false'); tg.focus(); }
      document.body.classList.remove('no-scroll');
      return;
    }

    /* Popups & cookie */
    var pc = t.closest('[data-popup-close]');
    if (pc) {
      var pop = pc.closest('[data-popup]');
      closeDrawer(pop);
      try { localStorage.setItem('amarelis_popup_until', String(Date.now() + (parseInt(pop.dataset.days, 10) || 7) * 86400000)); } catch (er) {}
      return;
    }
    if (t.closest('[data-cookie-accept]')) {
      try { localStorage.setItem('amarelis_cookie', '1'); } catch (er) {}
      var cn = $('[data-cookie-notice]'); if (cn) cn.hidden = true;
      return;
    }

    /* Back to top */
    if (t.closest('[data-to-top]')) { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); var sk = $('.skip-link'); if (sk) sk.focus(); return; }

    /* Carousel arrows */
    var cp = t.closest('[data-carousel-prev],[data-carousel-next]');
    if (cp) {
      var wrap = cp.closest('[data-carousel]');
      var track = $('[data-carousel-track]', wrap);
      if (track) track.scrollBy({ left: (cp.hasAttribute('data-carousel-next') ? 1 : -1) * track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' });
      return;
    }

    /* Video banner play (external video) */
    var vp = t.closest('[data-video-play]');
    if (vp) {
      var box = vp.closest('[data-video]');
      var src = vp.dataset.videoPlay;
      if (box && src) {
        var iframe = document.createElement('iframe');
        iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.title = vp.getAttribute('aria-label') || 'Video';
        iframe.setAttribute('loading', 'lazy');
        var holder = $('[data-video-frame]', box);
        if (holder) { holder.innerHTML = ''; holder.appendChild(iframe); box.classList.add('is-playing'); }
      }
      return;
    }
  });

  /* Filters: auto-submit */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-filter-form]');
    if (!form) return;
    if (e.target.matches('[data-sort-select]') || e.target.type === 'checkbox') form.submit();
  });

  /* =====================================================================
     Header: scrolled state
     ===================================================================== */
  function initHeader() {
    var h = $('[data-header]');
    if (!h || h.dataset.ready) return;
    h.dataset.ready = '1';
    var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 10); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* =====================================================================
     Back to top & cookie notice
     ===================================================================== */
  function initGlobals() {
    var tt = $('[data-to-top]');
    if (tt && !tt.dataset.ready) {
      tt.dataset.ready = '1';
      window.addEventListener('scroll', function () { tt.hidden = window.scrollY < 700; }, { passive: true });
    }
    var cn = $('[data-cookie-notice]');
    if (cn) { var ok = false; try { ok = localStorage.getItem('amarelis_cookie') === '1'; } catch (e) {} cn.hidden = ok; }
  }

  /* =====================================================================
     Scroll reveal
     ===================================================================== */
  var revealIO;
  function initReveal() {
    if (reduceMotion || !document.body.classList.contains('has-scroll-anim') || !('IntersectionObserver' in window)) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in-view'); revealIO.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    $$('main .shopify-section').forEach(function (sec, i) {
      if (i === 0 || sec.dataset.reveal) return;
      sec.dataset.reveal = '1';
      sec.classList.add('reveal');
      revealIO.observe(sec);
    });
  }

  /* =====================================================================
     Rate-us form
     ===================================================================== */
  function initRate(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var rating = 0;
    var stars = $$('[data-stars] button', form);
    var hint = $('[data-star-hint]', form);
    var labels = S.ratingLabels || [];
    function paint(n) { stars.forEach(function (s) { s.classList.toggle('on', parseInt(s.dataset.v, 10) <= n); }); }
    stars.forEach(function (s) {
      s.addEventListener('mouseenter', function () { paint(parseInt(s.dataset.v, 10)); });
      s.addEventListener('mouseleave', function () { paint(rating); });
      s.addEventListener('click', function () {
        rating = parseInt(s.dataset.v, 10);
        paint(rating);
        stars.forEach(function (x) { x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
        if (hint) hint.textContent = rating + ' / 5 — ' + (labels[rating] || '');
      });
    });
    form.addEventListener('submit', function (e) {
      var msg = $('[data-rate-msg]', form);
      var name = $('[name="contact[name]"]', form).value.trim();
      var email = $('[name="contact[email]"]', form).value.trim();
      var text = $('[data-rate-text]', form).value.trim();
      if (!rating || !name || !email || !text) {
        e.preventDefault();
        msg.className = 'msg err';
        msg.textContent = S.ratingMissing || '';
        return;
      }
      var sel = $('[data-rate-product]', form);
      var prod = sel ? sel.value : '';
      $('[data-rate-body]', form).value = 'Customer Review\nRating: ' + rating + ' / 5\nProduct: ' + (prod || 'Not specified') + '\n\n' + text;
      msg.className = 'msg';
      msg.textContent = S.ratingThanks || '';
    });
  }

  /* =====================================================================
     Product recommendations (Section Rendering API)
     ===================================================================== */
  function loadRecs(el) {
    if (el.dataset.loaded || !el.dataset.url) return;
    el.dataset.loaded = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCarousels(); }
    }).catch(function () {});
  }

  /* =====================================================================
     Recently viewed (rendered from localStorage)
     ===================================================================== */
  function initRecent(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var list = [];
    try { list = JSON.parse(localStorage.getItem('amarelis_recent') || '[]'); } catch (e) {}
    var path = window.location.pathname;
    list = list.filter(function (p) { return p && p.url && path.indexOf(p.url.split('?')[0]) === -1; });
    var limit = parseInt(el.dataset.limit, 10) || 4;
    list = list.slice(0, limit);
    if (!list.length) { el.hidden = true; return; }
    var rail = $('[data-recent-list]', el);
    rail.innerHTML = list.map(function (p) {
      return '<div class="card"><a class="img" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="img-main">' : '') +
        '</a><div class="meta"><div class="meta-main"><a class="n" href="' + esc(p.url) + '">' + esc(p.title) + '</a></div>' +
        '<span class="price p"><span class="price-now">' + esc(p.price) + '</span></span></div></div>';
    }).join('');
    el.hidden = false;
  }

  /* =====================================================================
     Slideshow
     ===================================================================== */
  function initSlideshow(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var track = $('[data-slides]', el);
    var slides = $$('[data-slide]', el);
    if (!track || slides.length < 2) return;
    var dots = $$('[data-dot]', el);
    var pauseBtn = $('[data-slide-pause]', el);
    var idx = 0, timer = null, userPaused = false;
    var speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
    var autoplay = el.dataset.autoplay === 'true' && !reduceMotion;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      mark();
    }
    function mark() {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); s.setAttribute('aria-hidden', n === idx ? 'false' : 'true'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
    }
    function start() { stop(); if (autoplay && !userPaused) timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    el.__stop = stop;

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-slide-prev]')) { go(idx - 1); start(); }
      else if (e.target.closest('[data-slide-next]')) { go(idx + 1); start(); }
      else { var d = e.target.closest('[data-dot]'); if (d) { go(parseInt(d.dataset.dot, 10)); start(); } }
      var pb = e.target.closest('[data-slide-pause]');
      if (pb) {
        userPaused = !userPaused;
        pb.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pb.textContent = userPaused ? pb.dataset.labelPlay : pb.dataset.labelPause;
        userPaused ? stop() : start();
      }
    });
    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      var n = Math.round(track.scrollLeft / w);
      if (n !== idx && slides[n]) { idx = n; mark(); }
    }, { passive: true });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    mark();
    start();
  }

  /* =====================================================================
     Countdown & stat counters
     ===================================================================== */
  function initCountdown(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var end = Date.parse(el.dataset.end);
    if (isNaN(end)) return;
    var parts = { d: $('[data-cd-days]', el), h: $('[data-cd-hours]', el), m: $('[data-cd-minutes]', el), s: $('[data-cd-seconds]', el) };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var sec = Math.floor(diff / 1000);
      if (parts.d) parts.d.textContent = pad(Math.floor(sec / 86400));
      if (parts.h) parts.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (parts.s) parts.s.textContent = pad(sec % 60);
      if (diff === 0) {
        clearInterval(el.__timer);
        var done = $('[data-cd-ended]', el); if (done) done.hidden = false;
        var grid = $('[data-cd-grid]', el); if (grid) grid.hidden = true;
      }
    }
    tick();
    el.__timer = setInterval(tick, 1000);
  }
  function initCounters(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var nums = $$('[data-count-to]', el);
    function run() {
      nums.forEach(function (n) {
        var target = parseFloat(n.dataset.countTo);
        if (isNaN(target) || reduceMotion) { n.textContent = n.dataset.countTo; return; }
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          n.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString();
          if (p < 1) requestAnimationFrame(step); else n.textContent = Number(target).toLocaleString();
        }
        requestAnimationFrame(step);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.3 });
      io.observe(el);
    } else run();
  }

  /* =====================================================================
     Email popup
     ===================================================================== */
  function initPopup(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    // After a successful signup the page reloads with a message: show it.
    if ($('[data-popup-success]', el)) { openDrawer(el); return; }
    var until = 0;
    try { until = parseInt(localStorage.getItem('amarelis_popup_until') || '0', 10); } catch (e) {}
    if (until > Date.now() && !(window.Shopify && window.Shopify.designMode)) return;
    var delay = (parseInt(el.dataset.delay, 10) || 8) * 1000;
    if (window.Shopify && window.Shopify.designMode) return; // in the editor it opens on section select
    el.__timer = setTimeout(function () { if (!openStack.length) openDrawer(el); }, delay);
  }

  /* =====================================================================
     Carousels (featured products)
     ===================================================================== */
  function initCarousels() { /* arrows are handled by delegated click; nothing to bind */ }

  /* =====================================================================
     Init + Theme Editor events
     ===================================================================== */
  function initVideoBg(v) {
    if (v.dataset.ready) return;
    v.dataset.ready = '1';
    var desktop = window.matchMedia('(min-width: 861px)').matches;
    if (desktop && !reduceMotion) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    else { v.controls = true; v.muted = false; }
  }

  function initAll(root) {
    root = root || document;
    initHeader();
    initGlobals();
    initReveal();
    $$('[data-rate-form]', root).forEach(initRate);
    $$('[data-recs]', root).forEach(loadRecs);
    $$('[data-recent]', root).forEach(initRecent);
    $$('[data-slideshow]', root).forEach(initSlideshow);
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-counters]', root).forEach(initCounters);
    $$('[data-popup]', root).forEach(initPopup);
    $$('[data-video-bg]', root).forEach(initVideoBg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-slideshow]', e.target).forEach(function (s) { if (s.__stop) s.__stop(); });
    $$('[data-countdown]', e.target).forEach(function (c) { clearInterval(c.__timer); });
    $$('[data-popup]', e.target).forEach(function (p) { clearTimeout(p.__timer); closeDrawer(p); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var pop = $('[data-popup]', e.target); if (pop) openDrawer(pop, { noLock: true });
    var cd = $('[data-cart-drawer]', e.target); if (cd) cd.classList.add('is-open');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pop = $('[data-popup]', e.target); if (pop) closeDrawer(pop);
    var cd = $('[data-cart-drawer]', e.target); if (cd) cd.classList.remove('is-open');
  });
})();
